import type { IconProps } from '../types/IconProps.ts';
export const Ticket: IconProps = {
    name: 'Ticket',
    children: [
        `<path d="M2 9V7c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v2M2 15v2c0 1.1.9 2 2 2h16a2 2 0 0 0 2-2v-2M2 15a3 3 0 1 0 0-6M22 15a3 3 0 1 1 0-6M13 5v3m0 11v-2m0-5v1" />`,
    ]
};